import { CalendarDays, Users } from 'lucide-react';

export function validDob(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
  const [year, month, day] = value.split('-').map(Number);
  const date = new Date(Date.UTC(year, month - 1, day));
  const now = new Date();
  return year >= 1900 && date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day && date.getTime() <= Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
}

export const profileStyles = {
  label: { display: 'block', color: '#c7b6e4', fontSize: 12, fontWeight: 650, marginBottom: 9 },
  input: { display: 'block', width: '100%', boxSizing: 'border-box', minHeight: 46, background: '#171125', color: '#f5eeff', padding: '11px 14px', border: '1px solid #4a3766', borderRadius: 11, outlineColor: '#b79ae5', fontSize: 14, colorScheme: 'dark' },
  button: { width: '100%', padding: '13px 16px', border: 'none', borderRadius: 11, color: '#1e1429', background: 'linear-gradient(120deg,#e8cf8d,#c9a84c)', fontWeight: 800, cursor: 'pointer', marginTop: 20, fontSize: 14 },
};

export default function ProfileDetailsForm({ dateOfBirth, gender, onDateOfBirth, onGender }) {
  const maxDate = new Date().toLocaleDateString('en-CA', { timeZone: 'UTC' });
  return <div style={{ display: 'grid', gap: 23 }}>
    <div>
      <label htmlFor="toa-birth-date" style={profileStyles.label}><CalendarDays size={15} style={{ verticalAlign: 'middle', marginRight: 8 }} />Date of birth</label>
      <input id="toa-birth-date" type="date" required max={maxDate} value={dateOfBirth} onChange={e => onDateOfBirth(e.target.value)} style={profileStyles.input} />
      <div style={{ color: '#998aaf', fontSize: 11, marginTop: 7 }}>Please enter your actual date of birth.</div>
    </div>
    <fieldset style={{ border: 0, margin: 0, padding: 0 }}>
      <legend style={profileStyles.label}><Users size={15} style={{ verticalAlign: 'middle', marginRight: 8 }} />Gender</legend>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 11 }}>
        {['male', 'female'].map(option => <label key={option} style={{ padding: '15px 10px', textAlign: 'center', cursor: 'pointer', borderRadius: 12, fontSize: 13, fontWeight: 700, border: `1px solid ${gender === option ? '#d6ba72' : '#47365f'}`, background: gender === option ? 'rgba(201,168,76,.15)' : 'rgba(255,255,255,.025)', color: gender === option ? '#f1d993' : '#b9a9d0' }}>
          <input type="radio" name="toa-gender" value={option} checked={gender === option} onChange={() => onGender(option)} style={{ accentColor: '#d6ba72', marginRight: 9 }} />
          <span aria-hidden="true" style={{ display: 'inline-block', marginRight: 7, fontSize: 18, fontFamily: 'Arial, sans-serif', fontWeight: 500, verticalAlign: 'middle', lineHeight: 1 }}>{option === 'male' ? '♂' : '♀'}</span>
          <span style={{ verticalAlign: 'middle' }}>{option === 'male' ? 'Male' : 'Female'}</span>
        </label>)}
      </div>
    </fieldset>
  </div>;
}
